module.exports = __webpack_public_path__ + "img/timeline-01.7f8d8e64.jpg";